import { gql } from '@apollo/client'
import { PDNFragments } from '../fragments/productDetailNote.fragment'

export const GetProductDetailNotes = gql`
    query getProductDetailNotes($input: GetProductDetailNotesSearchInput!) {
        getProductDetailNotes(input: $input) {
            skip
            take
            totalResult
            result {
                ...pdnCommonFragment
                seenByUserId
                metadata {
                    creatorId
                    created
                    updaterId
                    updated
                    createdBy {
                        role
                        userType
                        profileInfo {
                            firstName
                            lastName
                            title
                        }
                    }
                }
            }
        }
    }
    ${PDNFragments.pdnCommonFragment}
`

export const GetProductDetailNotesCount = gql`
    query getProductDetailNotes($input: GetProductDetailNotesSearchInput) {
        getProductDetailNotes(input: $input) {
            totalResult
            result {
                seenByUserId
            }
        }
    }
`

export const GetProductDetailNote = gql`
    query getProductDetailNote($input: string) {
        getProductDetailNotes(input: $input) {
            skip
            take
            totalResult
            result{
            ...pdnCommonFragment
            seenByUserId
            metadata {
                ...pdnMetadata
            }
            }
        }
    ${PDNFragments.pdnCommonFragment}
    ${PDNFragments.pdnMetadata}
    }
`

export const GetPDNNoteTypeReasons = gql`
    query getAllowedReasonsForProductDetailNoteType(
        $productDetailNoteType: ProductDetailNoteTypes
    ) {
        getAllowedReasonsForProductDetailNoteType(
            productDetailNoteType: $productDetailNoteType
        )
    }
`
